import dayjs from "@/lib/day";

export default function yupExpirationDateValidate(y) {
  y.addMethod(y.string, "expirationDate", function () {
    return this.test(
      "expirationDate",
      "無効な有効期限です。",
      function (value) {
        const date = dayjs(value, "YYYYMM").endOf("month");
        return dayjs().isBefore(date);
      }
    );
  });
}
